import { LocalDate, nativeJs, Period, ZoneId } from '@js-joda/core';

export class PeriodUtil {

  /**
   * Adds the given duration to now and returns its length in days.
   *
   * @param isoDuration an ISO 8601 period string (example: P1Y10M)
   * @return days since 1970-01-01 at the time "now + isoDuration"
   */
  public static getEpochDaysByIsoDuration(isoDuration: string): number {
    return PeriodUtil.getEpochDaysForPeriod(Period.parse(isoDuration));
  }

  /**
   * Calculates the amount of days between the two given dates.
   *
   * @param fromDate in milliseconds
   * @param toDate in milliseconds
   * @return days since 1970-01-01 at the time "now + difference of given dates"
   */
  public static getEpochDaysByDateDiff(fromDate: number, toDate: number): number {
    if (isNaN(fromDate) || isNaN(toDate)) {
      return;
    }
    const startDate = nativeJs(new Date(fromDate)).withZoneSameInstant(ZoneId.of('Europe/Berlin')).toLocalDate();
    const endDate = nativeJs(new Date(toDate)).withZoneSameInstant(ZoneId.of('Europe/Berlin')).toLocalDate();
    return PeriodUtil.getEpochDaysForPeriod(Period.between(startDate, endDate));
  }

  /**
   * Adds the given period to now and returns its length in days.
   *
   * @param period
   * @return days since 1970-01-01 at the time "now + period"
   */
  public static getEpochDaysForPeriod(period: Period): number {
    return period.addTo(LocalDate.now()).toEpochDay();
  }
}
